<template>
  <div>
    <div>
      <div v-if="loading" class="text-center" style="margin-top: 88px">
        <Loading></Loading>
      </div>
      <v-container
        v-else
        class="Kanit px-5"
        grid-list-xs
        style="padding-bottom: 100px"
      >
        <div>
          <div style="text-align: center" class="py-2 mb-2">
            <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
          </div>
        </div>
        <div class="text-center mb-4">
          <h3>กรอกข้อมูลหน้างาน</h3>
        </div>
        <div>
          <ValidationObserver ref="observer" tag="form">
            <form>
              <ValidationProvider
                :name="'ชื่อจริง'"
                :rules="'required'"
                key="firstname"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  large
                  class="mb-0"
                  outlined
                  @input="input.first_name = removeHiddenSpace($event)"
                  v-model="input.first_name"
                  placeholder="ชื่อจริง"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'นามสกุล'"
                :rules="'required'"
                key="lastname"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  large
                  class="mb-0"
                  outlined
                  @input="input.last_name = removeHiddenSpace($event)"
                  v-model="input.last_name"
                  placeholder="นามสกุล"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'เบอร์โทร'"
                :rules="'required|min:10'"
                key="Phoneno"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  name="phone"
                  large
                  class="mb-0"
                  outlined
                  type="number"
                  v-model="input.phoneno"
                  placeholder="เบอร์โทร"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>
              <template v-if="isNewUser">
                <ValidationProvider
                  :name="'อีเมล์'"
                  :rules="'required|email'"
                  key="Email"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    name="Email"
                    large
                    class="mb-0"
                    outlined
                    type="text"
                    @input="input.email = removeHiddenSpace($event)"
                    v-model="input.email"
                    placeholder="อีเมล์"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
              </template>
              <ValidationProvider
                :name="'รหัสไปรษณีย์'"
                :rules="'required'"
                key="zipcode"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.postcode"
                  type="zipcode"
                  @select="onSelectAddress"
                  :placeholder="`รหัสไปรษณีย์`"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'จังหวัด'"
                :rules="'required'"
                key="province"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.province"
                  type="province"
                  placeholder="จังหวัด"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>

              <ValidationProvider
                :name="'อำเภอ/เขต'"
                :rules="'required'"
                key="amphoe"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.sub_district"
                  type="amphoe"
                  placeholder="อำเภอ/เขต"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'ตำบล/แขวง'"
                :rules="'required'"
                key="district"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.district"
                  type="district"
                  placeholder="ตำบล/แขวง"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'ที่อยู่'"
                :rules="'required'"
                key="address"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  large
                  class="mb-0"
                  outlined
                  @input="input.address = removeHiddenSpace($event)"
                  v-model="input.address"
                  placeholder="รายละเอียดที่อยู่ บ้านเลขที่ หมู่บ้าน"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'พื้นที่ทาสี'"
                key="area"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  large
                  class="mb-0"
                  outlined
                  @input="input.paintarea = removeHiddenSpace($event)"
                  v-model="input.paintarea"
                  placeholder="พื้นที่ทาสี (ถ้ามี)"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>

              <div>
                <div style="font-weight: 600" class="mb-3">
                  อัพโหลดไฟล์ภาพบ้าน / อาคารที่ต้องการทาสี
                </div>
                <ValidationProvider
                  :name="'รูปภาพ'"
                  :rules="'required'"
                  key="photo"
                  v-slot="{ errors, valid }"
                >
                  <upload-multiple-file
                    v-model="input.photo"
                    :max="5"
                    data-vv-name="uploadMultipleFile"
                    data-vv-as="Preview Image"
                  ></upload-multiple-file>
                </ValidationProvider>
              </div>
              <div class="mt-2">
                <div
                  style="border-bottom: 0.8px solid #eee6e6; font-weight: 600"
                >
                  ประเภทหน้างาน
                </div>
                <div>
                  <ValidationProvider
                    :name="'ประเภทหน้างาน'"
                    :rules="'required'"
                    key="worktype"
                    v-slot="{ errors, valid }"
                  >
                    <v-radio-group
                      :error-messages="errors"
                      v-model="input.painttype"
                      row
                      x-small
                      class="radiotype"
                    >
                      <v-radio
                        color="#0c4d9d"
                        label="ทาสีภายใน/ภายนอก"
                        value="ทาสีภายใน/ภายนอก"
                      ></v-radio>
                      <v-radio
                        color="#0c4d9d"
                        label="ทาสีหลังคา"
                        value="ทาสีหลังคา"
                      ></v-radio>
                      <v-radio
                        color="#0c4d9d"
                        label="ทาสีตึกสูง"
                        value="ทาสีตึกสูง"
                      ></v-radio>
                      <v-radio
                        color="#0c4d9d"
                        label="ทาสีตกแต่งพิเศษ"
                        value="ทาสีตกแต่งพิเศษ"
                      ></v-radio>
                      <v-radio
                        color="#0c4d9d"
                        label="ทาสีงานไม้"
                        value="ทาสีงานไม้"
                      ></v-radio>
                      <v-radio
                        color="#0c4d9d"
                        label="ปูกระเบื้อง"
                        value="ปูกระเบื้อง"
                      ></v-radio>
                      <v-radio
                        color="#0c4d9d"
                        label="ติดตั้งฝ้าเพดาน และผนัง"
                        value="ติดตั้งฝ้าเพดาน และผนัง"
                      ></v-radio>
                      <v-radio
                        color="#0c4d9d"
                        label="ติดตั้งระบบกันซึม"
                        value="ติดตั้งระบบกันซึม"
                      ></v-radio>
                      <v-radio
                        color="#0c4d9d"
                        label="ทำระบบพื้นโรงงานอุตสาหกรรม"
                        value="ทำระบบพื้นโรงงานอุตสาหกรรม"
                      ></v-radio>
                    </v-radio-group>
                  </ValidationProvider>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>

        <div @click="confirmForm" v-ripple class="addcartbtn Kanit myshadow">
          <p v-if="!saveloading">ยืนยัน</p>
          <div v-else>
            <v-progress-circular
              indeterminate
              size="35"
              color="white"
            ></v-progress-circular>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import UploadMultipleFile from "@/components/UploadMultipleFile.vue";
import ThaiAddressInput from "@/components/ThaiAddressInput";
import axios from "axios";
import Loading from "@/components/Loading.vue";
export default {
  components: {
    Loading,
    UploadMultipleFile,
    ThaiAddressInput,
  },
  data() {
    return {
      loading: true,
      saveloading: false,
      orderid: "",
      isNewUser: false,
      input: {
        first_name: "",
        last_name: "",
        phoneno: "",
        postcode: "",
        email: "",
        province: "",
        sub_district: "",
        district: "",
        address: "",
        paintarea: "",
        photo: [],
        painttype: "",
      },
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  async mounted() {
    await this.checkLoginStatus();
    if (!this.$store.state.statuslogin) {
      await this.checkRegisterStatus();
    }
    await this.getDefaultInput();
    this.loading = false;
  },
  methods: {
    getDefaultInput() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get("https://communitybotbyzwizai.herokuapp.com/toapainterjobinfo", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: {
              userid: vm.$store.state.userid,
              apptype: vm.query.apptype,
              pageid: this.query.pageid,
            },
          })
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.data) {
              var data = response.data.data[0];
              Object.assign(vm.input, {
                first_name: data.first_name,
                last_name: data.last_name,
                phoneno: data.phoneno,
                postcode: data.zip_code,
                province: data.province,
                sub_district: data.sub_district,
                district: data.district,
                address: data.address1,
              });
            }

            resolve();
          });
      });
    },
    checkLoginStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckstatuslogincustomer",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: vm.$store.state.userid,
                apptype: vm.query.apptype,
                pageid: this.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 400) {
              vm.$store.state.statuslogin = false;
              resolve();
              //
            } else {
              vm.$store.state.statuslogin = true;
              resolve();
            }
          });
      });
    },
    checkFeyvery(data) {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckusersfeyverly",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                phoneno: data.phoneno,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              vm.$store.state.registerData = data;
              if (response.data.data[0].status) {
                // true
                vm.$store.state.registerType = "customerform";
                vm.query.view = "Login";
              } else {
                //false
                vm.$store.state.registerType = "customerform";
                vm.query.view = "OTP";
              }
            } else {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              resolve();
            }
          });
      });
    },

    checkRegisterStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckusersregister",
            {
              params: {
                userid: vm.$store.state.userid,
                apptype: vm.query.apptype,
                pageid: this.query.pageid,
              },
              headers: {
                AUTHORIZATION: "Bearer xxx xxx ",
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              return;
            } else if (response.data.responsecode == 200) {
              if (response.data.data[0].status) {
                //เคยสมัคร
                vm.$store.state.statusregister = true;
                vm.$store.state.redirect = "CustomerForm";
                vm.query.view = "Agreement";
                resolve();
              } else {
                vm.$store.state.statusregister = true;
                if (!vm.$store.state.viewAfterAgreement) {
                  vm.$store.state.viewAfterAgreement = "CustomerForm";
                  vm.query.view = "Agreement";
                  vm.loading = false;
                  resolve();
                } else {
                  vm.isNewUser = true;
                  vm.loading = false;
                  resolve();
                }
              }
            }
          });
      });
    },
    onSelectAddress(address) {
      this.input.sub_district = address.district;
      this.input.district = address.amphoe;
      this.input.province = address.province;
      this.input.postcode = address.zipcode;
    },
    async confirmForm() {
      if (!this.saveloading) {
        var vm = this;

        if (!this.input.photo.length) {
          this.$swal.fire({
            icon: "error",
            text: "กรุณาอัพโหลดรูปภาพอย่างน้อย 1 รูป",
          });
        }
        var isValid = await this.$refs.observer.validate();

        if (isValid && this.input.photo.length) {
          vm.saveloading = true;

          var data = {
            userid: vm.$store.state.userid,
            apptype: vm.query.apptype,
            pageid: this.query.pageid,
            first_name: this.input.first_name,
            last_name: this.input.last_name,
            phoneno: this.input.phoneno,
            email: this.input.email,
            address1: this.input.address, // ที่อยู่
            sub_district: this.input.sub_district, // ตำบล
            district: this.input.district, // อำเภอ
            province: this.input.province, // จังหวัด
            zip_code: this.input.postcode, // รหัสไปรษณีย์
            work_area: this.input.paintarea, // พื่นที่ในการทาสีส่งมาเป็น เลขทศนิยม 2 หลัก (ตร.ม.)
            work_area_images: this.input.photo, // รูปภาพสถานที่ เป็น array
            work_type: this.input.painttype, // ประเภทงาน
          };
          if (vm.isNewUser) {
            await vm.checkFeyvery(data);
          } else {
            axios
              .post(
                "https://communitybotbyzwizai.herokuapp.com/toapainterjobinfo",
                data,
                { headers: { AUTHORIZATION: "Bearer xxx xxx" } }
              )
              .then(async (response) => {
                vm.saveloading = false;
                if (response.data.responsecode == 200) {
                  this.$store.state.orderid = response.data.data[0].orderid;
                  await this.$swal.fire({
                    icon: "success",
                    text: "สำเร็จ",
                  });
                  if (this.query.apptype == "line") {
                    await this.$liff.closeWindow();
                  } else if (this.query.apptype == "facebook") {
                    this.$store.dispatch("messengerClose");
                  }
                  // this.query.view = "SelectPainter";
                } else {
                  await this.$swal.fire({
                    icon: "error",
                    text: response.data.reason,
                  });
                }
              });
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
.radiotype label {
  font-size: 13px;
}
</style>